var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.431 31.969-3.813-1.106a.75.75 0 0 1-.512-.931L21.637.545a.75.75 0 0 1 .931-.512l3.813 1.106a.75.75 0 0 1 .512.931l-8.531 29.387a.748.748 0 0 1-.931.512zm-7.125-7.013a.746.746 0 0 1-1.063.031L.237 16.543a.745.745 0 0 1 0-1.094l9.006-8.438a.751.751 0 0 1 1.063.031l2.719 2.9a.744.744 0 0 1-.05 1.075l-5.662 4.981 5.662 4.981a.75.75 0 0 1 .05 1.075zm20.45.038a.751.751 0 0 1-1.063-.038l-2.719-2.9a.744.744 0 0 1 .05-1.075L32.686 16l-5.662-4.988a.75.75 0 0 1-.05-1.075l2.719-2.9a.757.757 0 0 1 1.063-.031l9.006 8.45c.319.294.319.8 0 1.094z"}));
}

Code.defaultProps = {"viewBox":"0 0 40 32"};

module.exports = Code;

Code.default = Code;
